import React from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  ThemeProvider,
  createTheme,
  CssBaseline,
  List,
  ListItem,
  ListItemText,
  Link,
  useMediaQuery,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Pageheader } from "./global-components/page-header";
import CookieTables from "./section-components/CookiesTable";
import bgImage from '../assets/img/newimgaes/T and cs policy.jpeg';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: "#10374A",
    },
    text: {
      primary: "#10374A",
      secondary: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h4: {
      fontWeight: 700,
      fontSize: "2rem",
      color: "#10374A",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
    },
  },
});
const CookiesPolicy = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Pageheader headertitle={"Cookies Policy"} bgImage={bgImage} />
      <Container maxWidth="md" sx={{ padding: "2rem 1rem" }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          COOKIE POLICY
        </Typography>
        <Card sx={{ backgroundColor: "#F9FAFB", marginBottom: "1.5rem" }}>
          <CardContent>
            <Typography variant="body1" color="text.primary">
              This website royalespaces.in (“Our Site”) uses Cookies and similar technologies to distinguish you from other users. By using Cookies, we can provide you with a better experience and improve Our Site by better understanding how you use it. Please read this Cookie Policy carefully and ensure that you understand it. Your acceptance of Our Cookie Policy is deemed to occur if you continue using Our Site or click the “Accept” button on Our Cookie pop-up. If you do not agree to Our Cookie Policy, please stop using Our Site immediately.
            </Typography>
          </CardContent>
        </Card>
        <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A", color: '#fff' }} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
          >
            <Typography color="#fff">Definitions and Interpretation</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
            <Typography variant="body1" color="text.primary">
              In this Cookie Policy, unless the context otherwise requires, the following expressions have the following meanings:
            </Typography>
            <Box component={'div'} sx={{ mt: 2 }} color="text.primary">
              <Box sx={{ display: 'flex', mb: 2 }}>
                <Box sx={{ minWidth: '150px' }}><strong>“Cookie”</strong></Box>
                <Box><p>means a small file placed on your computer or device by Our Site when you visit certain parts of Our Site and/or when you use certain features of Our Site;</p></Box>
              </Box>
              <Box sx={{ display: 'flex', mb: 2 }}>
                <Box sx={{ minWidth: '150px' }}><strong>“Cookie Law”</strong></Box>
                <Box><p>means the Information Technology Act, 2000, the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, and any other applicable Indian data protection laws;</p></Box>
              </Box>
              <Box sx={{ display: 'flex', mb: 2 }}>
                <Box sx={{ minWidth: '150px' }}><strong>“personal data”</strong></Box>
                <Box><p>means all data that relates to an identifiable individual who can be directly or indirectly identified from that data, as defined under applicable Indian data protection laws; and</p></Box>
              </Box>
              <Box sx={{ display: 'flex', mb: 2 }}>
                <Box sx={{ minWidth: '150px' }}><strong>“We/Us/Our”</strong></Box>
                <Box><p>means Royale Spaces Limited, a company registered in India, whose registered and main trading address is: Door No. 7-331/20, Tulasi Plaza, M.M. Donka (O), Ongole, Prakasam – 523002, Andhra Pradesh.</p></Box>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
          >
            <Typography color="#fff">Information About Us</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
            <Typography variant="body1" color="text.primary">
              Our Site is owned and operated by Royale Spaces (India) Limited, a company registered in India.
            </Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              Our Data Protection Officer can be contacted by:
            </Typography>
            <Box sx={{ pl: 2, mt: 1 }}>
              <Typography variant="body1" color="text.primary"><strong>Email:</strong> info@royalespaces.com</Typography>
              <Typography variant="body1" color="text.primary"><strong>Telephone:</strong> +91-7893092211</Typography>
              <Typography variant="body1" color="text.primary"><strong>Postal address:</strong> Door No. 7-331/20, Tulasi Plaza, M.M. Donka (O), Ongole, Prakasam – 523002, Andhra Pradesh.</Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
          >
            <Typography color="#fff">How Does Our Site Use Cookies?</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
            <Typography variant="body1" color="text.primary">
              <strong>3.1</strong> Our Site may place and access certain first-party Cookies on your computer or device. First-party Cookies are those placed directly by Us and are used only by Us. We use Cookies to facilitate and improve your experience of Our Site and to provide and improve Our services. We have carefully chosen these Cookies and have taken steps to ensure that your privacy and personal data are protected at all times.
            </Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>3.2</strong> By using Our Site, you may also receive certain third-party Cookies on your computer or device. Third-party Cookies are those placed by websites, services, and/or parties other than Us. These Cookies may be used for analytics, marketing, or advertising purposes.
            </Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>3.3</strong> All Cookies used by and on Our Site are used in accordance with applicable Indian laws. We may use some or all of the following types of Cookies:
            </Typography>
            <List sx={{ pl: 2 }}>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="3.3.1 Strictly Necessary Cookies"
                  secondary="These Cookies are essential to the operation of Our Site, supporting functions such as security, form submissions, and basic navigation."
                  secondaryTypographyProps={{ style: { color: '#10374A' } }}
                />
              </ListItem>

              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="3.3.2 Analytics Cookies"
                  secondary="These Cookies help Us understand how users interact with Our Site, enabling Us to improve functionality, performance, and user experience."
                  secondaryTypographyProps={{ style: { color: '#10374A' } }}
                />
              </ListItem>

              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="3.3.3 Functionality Cookies"
                  secondary="These Cookies allow Our Site to remember choices you make (such as language preferences) and provide enhanced, more personalised features."
                  secondaryTypographyProps={{ style: { color: '#10374A' } }}
                />
              </ListItem>

              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="3.3.4 Targeting Cookies"
                  secondary="These Cookies record your visit to Our Site, the pages you have visited, and the links you have followed, helping Us deliver relevant advertisements."
                  secondaryTypographyProps={{ style: { color: '#10374A' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="3.3.5 Third-Party Cookies"
                  secondary="These Cookies are placed by third parties that provide services such as analytics, advertising, or embedded content."
                  secondaryTypographyProps={{ style: { color: '#10374A' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="3.3.6 Persistent Cookies"
                  secondary="These Cookies remain on your device for a specified period and are activated each time you visit Our Site."
                  secondaryTypographyProps={{ style: { color: '#10374A' } }}
                />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="3.3.7 Session Cookies"
                  secondary="These Cookies are temporary and are deleted when you close your browser."
                  secondaryTypographyProps={{ style: { color: '#10374A' } }}
                />
              </ListItem>
            </List>
            <Typography variant="body1" color="text.primary">
              <strong>3.4</strong> Cookies on Our Site are not permanent and will expire.</Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>3.5</strong> For more details of the personal data that We collect and use, please refer to Our Privacy Policy.</Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>3.6</strong> For more specific details of the Cookies that We use, please refer to the table below.</Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
          >
            <Typography color="#fff">What Cookies Does Our Site Use?</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
            <CookieTables />
            <Typography variant="body1" color="text.primary" sx={{ mt: 2 }}>
              <strong>4.3</strong> Our Site uses analytics services. These services collect and analyse anonymous usage information to help Us understand how Our Site is used and improve Our services.
            </Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>4.4</strong> The analytics services used by Our Site use analytics Cookies to gather this information.
            </Typography>
            <CookieTables notTable />
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
          >
            <Typography color="#fff">Consent and Control</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
            <Typography variant="body1" color="text.primary">
              <strong>5.1</strong> Before Cookies are placed on your device, you will be shown a pop-up requesting your consent. By giving your consent, you enable Us to provide the best possible experience and service. You may refuse consent for non-essential Cookies; however, certain features of Our Site may not function as intended.
            </Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>5.2</strong> In addition to the controls provided by Us, you can enable or disable Cookies in your browser settings. Most browsers allow you to control cookies, including blocking or deleting them.
            </Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>5.3</strong> Instructions for managing Cookies in popular browsers:
            </Typography>
            <List sx={{ pl: isMobile ? 2 : 4 }}>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="Google Chrome:"
                  secondary={
                    <Link
                      href="https://support.google.com/chrome/answer/95647"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: '#10374A !important', wordBreak: 'break-word' }}
                    >
                      https://support.google.com/chrome/answer/95647
                    </Link>
                  }
                />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="Microsoft Edge:"
                  secondary={
                    <Link
                      href="https://support.microsoft.com/en-gb/products/microsoft-edge"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: '#10374A !important', wordBreak: 'break-word' }}
                    >
                      https://support.microsoft.com/en-gb/products/microsoft-edge
                    </Link>
                  }
                />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="Safari (macOS):"
                  secondary={
                    <Link
                      href="https://support.apple.com/kb/PH21411"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: '#10374A !important', wordBreak: 'break-word' }}
                    >
                      https://support.apple.com/kb/PH21411
                    </Link>
                  }
                />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="Safari (iOS):"
                  secondary={
                    <Link
                      href="https://support.apple.com/HT201265"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: '#10374A !important', wordBreak: 'break-word' }}
                    >
                      https://support.apple.com/HT201265
                    </Link>
                  }
                />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText
                  primary="Android:"
                  secondary={
                    <Link
                      href="https://support.google.com/chrome/answer/95647?hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ color: '#10374A !important', wordBreak: 'break-word' }}
                    >
                      https://support.google.com/chrome/answer/95647?hl=en
                    </Link>
                  }
                />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
          >
            <Typography color="#fff">Changes to This Cookie Policy</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
            <Typography variant="body1" color="text.primary">
              <strong>6.1</strong> We may alter this Cookie Policy at any time. Any changes will be posted on this page and will become effective immediately upon publication.
            </Typography>
            <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
              <strong>6.2</strong> In the event of any conflict between the current version of this Cookie Policy and any previous versions, the current version shall prevail unless expressly stated otherwise.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
          >
            <Typography color="#fff">Further Information</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
            <Typography variant="body1" color="text.primary">
              <strong>7.1</strong> If you would like to know more about how We use Cookies, please contact Us at:
            </Typography>
            <Box sx={{ pl: 2, mt: 1 }}>
              <Typography variant="body1" color="text.primary"><strong>Email:</strong> info@royalespaces.com</Typography>
              <Typography variant="body1" color="text.primary"><strong>Telephone:</strong> +91-7893092211</Typography>
              <Typography variant="body1" color="text.primary"><strong>Postal address:</strong> Door No. 7-331/20, Tulasi Plaza, M.M. Donka (O), Ongole, Prakasam – 523002, Andhra Pradesh.</Typography>
            </Box>
            <Typography variant="body1" color="text.primary" sx={{ mt: 2 }}>
              <strong>7.2</strong> For more information, please refer to Our Privacy Policy, Data Protection Policy, and Terms and Conditions available on Our website.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Container>
    </ThemeProvider >
  );
};

export default CookiesPolicy;
